import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  LandingEntry,
  LandingRestaurants,
  LandingConsumers,
  LandingCompanies,
  LandingAbout,
} from "./pages/landing";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ConfirmAccount from "./pages/auth/ConfirmAccount";
import ConfirmPassword from "./pages/auth/ConfirmPassword";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ChangeForgotPassword from "./pages/auth/ChangeForgotPassword";
import Dashboard from "./pages/Dashboard";
import DemoDashboard from "./pages/DemoDashboard";
import Support from "./pages/Support";
import TermsAndConditions from "./pages/legal/TermsAndConditions";
import ConsentAndCookies from "./pages/legal/ConsentAndCookies";
import LegalMentions from "./pages/legal/LegalMentions";
import NotFound from "./pages/errors/NotFound";
import SecurityWarning from "./pages/errors/SecurityWarning";
import Cookie from "./components/utils/Cookie";
import ScrollToTop from "./components/utils/ScrollToTop";
import LanguageLogic from "./components/HOC/LanguageLogic";
import StoreRedirect from "./pages/StoreRedirect";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getEnvVariable } from "./utils/config";

const App = () => {
  return (
    <>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <GoogleOAuthProvider
        clientId={getEnvVariable("REACT_APP_GOOGLE_CLIENT_ID")}
      >
        <Router>
          <ScrollToTop />
          <Cookie />
          <Routes>
            <Route path="/" element={<LanguageLogic />} />
            <Route path="storeRedirect" element={<StoreRedirect />} />
            <Route
              path=":lang/*"
              element={
                <LanguageLogic>
                  <Routes>
                    <Route path="/" element={<LandingEntry />} />
                    <Route
                      path="restaurants"
                      element={<LandingRestaurants />}
                    />
                    <Route path="consumers" element={<LandingConsumers />} />
                    <Route path="companies" element={<LandingCompanies />} />
                    <Route path="about" element={<LandingAbout />} />
                    <Route path="login" element={<Login />} />
                    <Route path="register" element={<Register />} />
                    <Route
                      path="register/:referralCode"
                      element={<Register />}
                    />
                    <Route
                      path="confirmAccount/:activationCode"
                      element={<ConfirmAccount />}
                    />
                    <Route path="forgotPassword" element={<ForgotPassword />} />
                    <Route
                      path="changeForgotPassword/:username/:forgotPasswordToken"
                      element={<ChangeForgotPassword />}
                    />
                    <Route
                      path="resetPassword/:username"
                      element={<ChangeForgotPassword />}
                    />
                    <Route
                      path="confirmPassword/:username"
                      element={<ConfirmPassword />}
                    />
                    <Route path="demo/*" element={<DemoDashboard />} />
                    <Route path="dashboard/*" element={<Dashboard />} />
                    <Route
                      path="termsAndConditions"
                      element={<TermsAndConditions />}
                    />
                    <Route
                      path="consentAndCookies"
                      element={<ConsentAndCookies />}
                    />
                    <Route path="legalMentions" element={<LegalMentions />} />
                    <Route path="support" element={<Support />} />
                    <Route
                      path="security-warning"
                      element={<SecurityWarning />}
                    />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </LanguageLogic>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
      </GoogleOAuthProvider>
    </>
  );
};

export default App;
